import { Component, OnInit } from "@angular/core";
import { MainService } from "../../../services/main/main.service";
import { LoaderService } from "src/app/services/interceptor/loader.service";
import { getUserProfile, getUserProfiles } from 'src/app/core/session';

@Component({
  selector: "app-payouts",
  templateUrl: "./payouts.component.html",
  styleUrls: ["./payouts.component.scss"],
})
export class PayoutsComponent implements OnInit {
  can_schedule_payout: any;
  payoutType: any = "Daily";
  payoutDay: any = ''
  monthday = [...Array(31)];
  change: boolean = true;
  payoutSchedule: any;
  payoutSchedule_1: any;
  userProfileData: any;

  constructor(
    private mainService: MainService,
    public loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.userProfileData = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();
    this.retrieveSchedule();
  }

  payoutSchedues(list) {
    this.payoutSchedule_1 = list.value;
    try {
      let payoutdata = {
        access_token: localStorage.getItem('token'),
        payout_schedule: 'no',
        reports_hard_copy: list.value
      }
      this.sendPayoutSchedule(payoutdata, 'second')
    } catch (error) {
      console.log(error)
    }
  }

  retrieveSchedule() {
    let formdata = {}
    let accessToken = localStorage.getItem("token");
    let doctor_id = this.userProfileData.doctor_id;
    formdata["access_token"] = accessToken
    formdata["doctor_id"] = doctor_id
    this.mainService
      .uploadApi(formdata, "retrieve_payout_schedule", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          try {
            this.loaderService.hide();
            this.change = true;
            this.payoutSchedule = data;

            // Schedule 1234
            if (data && data.payout_schedule && data.payout_schedule.interval) {
              this.payoutType = data.payout_schedule.interval == 'monthly' ? "Monthly" : data.payout_schedule.interval == 'weekly' ? 'Weekly' : data.payout_schedule.interval == 'daily' ? 'Daily' : data.payout_schedule.interval;
            }

            // Weekly value
            if (data && data.payout_schedule && data.payout_schedule.weekly_anchor) {
              this.payoutDay = data.payout_schedule.weekly_anchor;
            }

            // monthly value
            if (data && data.payout_schedule && data.payout_schedule.monthly_anchor) {
              this.payoutDay = parseInt(data.payout_schedule.monthly_anchor);
            }
            this.payoutSchedule_1 = data.reports_hard_copy;
            this.payoutSchedues["payoutMode"] = data.payout_schedule.interval == "daily" ? "1" : data.payout_schedule.interval == "weekly" ? "2" : "3";
            this.can_schedule_payout = data.can_schedule_payout;

          } catch (error) {
            console.log(error);
          }
        }
      });
  }

  schedulePayout() {
    try {
      let formdata = { payout_schedule: null };
      let token = localStorage.getItem("token");
      formdata["access_token"] = token;
      formdata["doctor_id"] = this.userProfileData.doctor_id;
      formdata["payout_schedule"] = this.payoutType == "Weekly" ? 2 : this.payoutType == "Monthly" ? 3 : 1
      if (this.payoutSchedule_1 !== undefined) {
        formdata['reports_hard_copy'] = this.payoutSchedule_1;
      }
      if (this.payoutType == "Monthly") {
        formdata["month_day"] = this.payoutDay.toString()
      }
      if (this.payoutType == "Weekly") {
        formdata["week_day"] = this.payoutDay.toLowerCase()
      }
      if (this.payoutDay) {
        if (this.payoutType == "Monthly" && !isNaN(this.payoutDay)) {
          return this.sendPayoutSchedule(formdata, 'first');
        }
        if (this.payoutType == "Weekly" && isNaN(this.payoutDay)) {
          return this.sendPayoutSchedule(formdata, 'first');
        }
        this.sendPayoutSchedule(formdata, 'first')
      }
      else {
        if(this.payoutType == "Daily"){
          this.sendPayoutSchedule(formdata, 'first')
        }else{
          this.mainService.customPopups("Please select valid payout schedule", 1);
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  sendPayoutSchedule(formdata, value) {
    this.mainService
      .uploadApi(formdata, "schedule_payouts", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.retrieveSchedule();
          if (value == 'second') {
            this.mainService.customPopups("Paper statement requirement updated successfully", 0);
          }
          else {
            this.mainService.customPopups("Payouts scheduled successfully", 0)
          }
        }
      });
  }

  changeDay(event) {
    if (this.payoutDay) {
      this.change = false
    } else {
      this.payoutDay = event;
      this.change = true
    }
  }

  daily() {
    this.change = false
    this.payoutDay = ''
  }

  week() {
    this.change = true
    this.payoutDay = ''
  }
}
